export const SmallWidth = 520
export const MediumWidth = 800

export const SmallMediaQuery = "(max-width: " + SmallWidth + "px)"
export const MediumMediaQuery = "(max-width: " + MediumWidth + "px)"
